import api, { apiInternal } from '../api';


export async function getCustomActivities(id) {
  const { data } = await api.post(`${apiInternal}/establishment/params/getCustomActivities`, {esta_id: id});
  return data;
}

export async function setCustomActivities(id, rows) {
  rows.append('esta_id', id);
  return new Promise((resolve, reject) => {
    api.post(`${apiInternal}/import/Activities`,
      rows,
      { headers: { 'Content-type': 'multipart/form-data' }, }
      )
      .then((response)=> resolve(response))
      .catch((err)=> reject({error: err.response.data}));
  });
  //return data
}